import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import { BRAND } from "../../lib/config";
import { ArrowUpRight } from "lucide-react";

function FooterLink({ href, children }) {
  return (
    <a
      href={href}
      className="text-sm text-white/65 hover:text-white transition inline-flex items-center gap-1"
    >
      {children}
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="bg-[#070A0F] border-t border-white/10">
      <Container className="py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* Brand column */}
          <div className="md:col-span-5">
            <a href="/" className="inline-flex items-center gap-3">
              <img
                src="/branding/xah-text-refined.png"
                alt={`${BRAND.name} logo`}
                className="h-15 w-auto"
                loading="lazy"
              />
            </a>

            <p className="mt-4 max-w-sm text-sm leading-6 text-white/65">
              Transparent £/GB pricing, modern hardware, and human support — built for communities
              that care about performance.
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Button href={BRAND.deployUrl} className="sm:w-auto">
                Deploy
              </Button>
              <Button variant="secondary" href={BRAND.discordUrl} className="sm:w-auto">
                Join Discord <ArrowUpRight className="h-4 w-4 opacity-70" />
              </Button>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-7 grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <div className="text-xs font-semibold tracking-wider text-white/50">PRODUCTS</div>
              <div className="mt-4 flex flex-col gap-2">
                <FooterLink href={BRAND.gameHostingUrl}>Game Hosting</FooterLink>
                { /* <FooterLink href={BRAND.dedicatedUrl}>Dedicated Servers</FooterLink> */}
                <FooterLink href={BRAND.webHostingUrl}>Web Hosting</FooterLink>
              </div>
            </div>

            <div>
              <div className="text-xs font-semibold tracking-wider text-white/50">COMPANY</div>
              <div className="mt-4 flex flex-col gap-2">
                <FooterLink href={BRAND.statusUrl}>Status</FooterLink>
                <FooterLink href={BRAND.supportUrl}>Support</FooterLink>
              </div>
            </div>

            <div>
              <div className="text-xs font-semibold tracking-wider text-white/50">LEGAL</div>
              <div className="mt-4 flex flex-col gap-2">
                <FooterLink href="/legal#terms">Terms</FooterLink>
                <FooterLink href="/legal#privacy">Privacy</FooterLink>
                <FooterLink href="/legal#sla">SLA</FooterLink>
                <FooterLink href="/legal#imprint">Imprint</FooterLink>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>

          <div className="text-xs text-white/50">
            Built for speed <span className="text-white/30">•</span> Priced fairly{" "}
            <span className="text-white/30">•</span> Supported by humans
          </div>
        </div>
      </Container>
    </footer>
  );
}
